/**
 * Whether the Unzer web-component SDK (unzer-payment, unzer-customer-form)
 * has been loaded into the page this session. It's injected lazily, only
 * once the MOTO order-creation modal is opened — see
 * apps/unzer/views/orders/reports_orders/components/create-order-modal/payment-section.vue.
 * @returns {boolean}
 */
export function isUnzerSdkLoaded() {
  return (
    !!customElements.get('unzer-payment') ||
    !!customElements.get('unzer-customer-form')
  )
}
